// helpers/AdminConfigHelper.js
import ApiHelper from "../../ApiHelper";
import API_ENDPOINTS from "../../endpoints";

class AdminConfigHelper {
  

    // ================================UTILITY METHODS ================================ //
  

static async getAllColleges(){

    // eslint-disable-next-line no-useless-catch
    try{
      const response = await ApiHelper.get(API_ENDPOINTS.ADMIN_CONFIG.BASICS.COLLEGES);
      return response;
    }catch(error){
      throw error;
    }
}

static async getAllSmes(){

    // eslint-disable-next-line no-useless-catch
    try{
      const response = await ApiHelper.get(API_ENDPOINTS.ADMIN_CONFIG.BASICS.SMES);
      return response;
    }catch(error){
      throw error;
    }
}


static async getAllCourses(){

    // eslint-disable-next-line no-useless-catch
    try{
      const response = await ApiHelper.get(API_ENDPOINTS.ADMIN_CONFIG.BASICS.COURSES);
      return response;
    }catch(error){
      throw error;
    }
}

static async getAllDegrees(){

    // eslint-disable-next-line no-useless-catch
    try{
      const response = await ApiHelper.get(API_ENDPOINTS.ADMIN_CONFIG.BASICS.DEGREES);
      return response;
    }catch(error){
      throw error;
    } 
  }

  static async getDashboardStats(params = {}) {
    //eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.get(API_ENDPOINTS.ADMIN_CONFIG.DASHBOARD.STATS, { params });
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async getSystemHealth() {
  // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.get(API_ENDPOINTS.ADMIN_CONFIG.DASHBOARD.HEALTH);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // ================================COLLEGE COURSE MAPPING ================================ //
  
  static async getCollegeCourseMappings(params = {}) {
    console.log('AdminConfigHelper: Fetching College Course Mappings with params:', {params});
      // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.get(API_ENDPOINTS.ADMIN_CONFIG.COLLEGE_COURSE_MAPPINGS.GET_ALL,  params );
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async createCollegeCourseMapping(data) {
      // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.post(API_ENDPOINTS.ADMIN_CONFIG.COLLEGE_COURSE_MAPPINGS.CREATE, data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async updateCollegeCourseMapping(mappingId, data) {
      // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.post(
        API_ENDPOINTS.ADMIN_CONFIG.COLLEGE_COURSE_MAPPINGS.UPDATE.replace(':mappingId', mappingId), 
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async getDegreesByCollege(collegeId) {
      // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.get(
        API_ENDPOINTS.ADMIN_CONFIG.BASICS.DEGREESBYCOLLEGE.replace(':collegeId', collegeId)
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

      

  static async deleteCollegeCourseMapping(mappingId) {
      // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.delete(
        API_ENDPOINTS.ADMIN_CONFIG.COLLEGE_COURSE_MAPPINGS.DELETE.replace(':mappingId', mappingId)
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  // ================================SME COURSE MAPPING ================================ //
  
  static async getSMECourseMappings(params = {}) {
      // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.get(API_ENDPOINTS.ADMIN_CONFIG.SME_COURSE_MAPPINGS.GET_ALL,  params );
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async createSMECourseMapping(data) {
      // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.post(API_ENDPOINTS.ADMIN_CONFIG.SME_COURSE_MAPPINGS.CREATE, data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async deleteSMECourseMapping(mappingId) {
      // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.delete(
        API_ENDPOINTS.ADMIN_CONFIG.SME_COURSE_MAPPINGS.DELETE.replace(':mappingId', mappingId)
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  // ================================DEGREE COURSE MAPPING ================================ //
  
  static async getDegreeConfigurations(params = {}) {
      // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.get(API_ENDPOINTS.ADMIN_CONFIG.DEGREE_CONFIGURATIONS.GET_ALL, { params });
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async createDegreeConfiguration(data) {
      // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.post(API_ENDPOINTS.ADMIN_CONFIG.DEGREE_CONFIGURATIONS.CREATE, data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async updateDegreeConfiguration(degreeId, data) {
      // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.post(
        API_ENDPOINTS.ADMIN_CONFIG.DEGREE_CONFIGURATIONS.UPDATE.replace(':degreeId', degreeId), 
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async deleteDegreeConfiguration(degreeId) {
      // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.delete(
        API_ENDPOINTS.ADMIN_CONFIG.DEGREE_CONFIGURATIONS.DELETE.replace(':degreeId', degreeId)
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async createSemesterConfiguration(data) {
      // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.post(API_ENDPOINTS.ADMIN_CONFIG.DEGREE_CONFIGURATIONS.CREATE_SEMESTER, data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // ================================COURSE CATEGORIES ================================ //
  
  static async getCourseCategories(params = {}) {
      // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.get(API_ENDPOINTS.ADMIN_CONFIG.COURSE_CATEGORIES.GET_ALL, { params });
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async createCourseCategory(data) {
      // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.post(API_ENDPOINTS.ADMIN_CONFIG.COURSE_CATEGORIES.CREATE, data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // ================================COURSE PREREQUISITES ================================ //
  
  static async getCoursePrerequisites(courseId = '', params = {}) {
      // eslint-disable-next-line no-useless-catch
    try {
      const endpoint = courseId 
        ? API_ENDPOINTS.ADMIN_CONFIG.COURSE_PREREQUISITES.GET_BY_COURSE.replace(':courseId', courseId)
        : API_ENDPOINTS.ADMIN_CONFIG.COURSE_PREREQUISITES.GET_ALL;
      
      const response = await ApiHelper.get(endpoint, { params });
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async addCoursePrerequisite(data) {
      // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.post(API_ENDPOINTS.ADMIN_CONFIG.COURSE_PREREQUISITES.CREATE, data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async removeCoursePrerequisite(prerequisiteId) {
      // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.delete(
        API_ENDPOINTS.ADMIN_CONFIG.COURSE_PREREQUISITES.DELETE.replace(':prerequisiteId', prerequisiteId)
      );
      return response;
    } catch (error) {
      throw error;
    }
  }


// ================================COLLEGE DEGREE MAPPINGS ================================ //
  
static async createCollegeDegreeMapping(data) {
      // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.post(API_ENDPOINTS.ADMIN_CONFIG.COLLEGE_DEGREE_MAPPINGS.CREATE, data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async updateCollegeDegreeMapping(mappingId, data) {
    // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.post(
        API_ENDPOINTS.ADMIN_CONFIG.COLLEGE_DEGREE_MAPPINGS.UPDATE.replace(':mappingId', mappingId),
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async deleteCollegeDegreeMapping(mappingId) {
    // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.delete(  
        API_ENDPOINTS.ADMIN_CONFIG.COLLEGE_DEGREE_MAPPINGS.DELETE.replace(':mappingId', mappingId)
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

static async getCollegeDegreeMappings(params = {}) {
    console.log('AdminConfigHelper: Fetching College Degree Mappings with params:', {params});
      // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.get(API_ENDPOINTS.ADMIN_CONFIG.COLLEGE_DEGREE_MAPPINGS.GET_ALL,  params );
      return response;
    } catch (error) {
      throw error;
    }
  }

  // ================================SEMESTER PROMOTION ================================ //

  static async promoteSemester(data) {
    // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.post(API_ENDPOINTS.ADMIN_CONFIG.SEMESTER_PROMOTION.PROMOTE, data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async previewSemesterPromotion(data) {
    // eslint-disable-next-line no-useless-catch
    try {
      const response = await ApiHelper.post(API_ENDPOINTS.ADMIN_CONFIG.SEMESTER_PROMOTION.PREVIEW, data);
      return response;
    } catch (error) {
      throw error;
    }
  }


}

export default AdminConfigHelper;
